import React, { Component } from 'react'
import Grid from '@mui/material/Grid'
import MatchNav from './Match/MatchNav'
import Profile from './Match/Profile'
import Stories from './Match/Stories'
import Connect from './Match/Connect'
import matchConfig from '../../config/matchConfig'

class Match extends Component {
    constructor(props) {
        super(props)
        this.state = {
            inlineAI: false
        }
    }

    render() {
        // console.log(this.props)
        const { inlineAI } = this.state
        const commonProps = { ...this.props, openInlineAI: this.openInlineAI }


        switch(this.props.page) {
            case matchConfig.pages.story:
                return (
                    <MatchNav {...commonProps}>
                        <Stories {...this.props}/>
                    </MatchNav>)
            case matchConfig.pages.chat:
                return (
                    <MatchNav {...commonProps}>
                        <Connect {...this.props}/>
                    </MatchNav>)
            case matchConfig.pages.profile:
            default:
                return (
                    <MatchNav {...commonProps}>
                        <Profile {...this.props}/>
                    </MatchNav>)
        }
    }
}

export default Match